import React, { Component, Fragment } from "react";
import { connect } from 'react-redux'
import { Formik, Form, Field, ErrorMessage } from "formik";

import { toast } from 'react-toastify';

import { withRouter } from 'react-router-dom'

import * as Yup from "yup";
import axios from "axios";

import { userLogin } from '../../../redux/auth/actions';

const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email")
      .required("Required"),
      password: Yup.string()
      .required("Required")
});


class LoginForm extends Component {
    
    render() {
      return (
        <Fragment>
        <Formik
        initialValues={{ email: '', password: '' }}
        validationSchema={LoginSchema}
        onSubmit={(values, { setSubmitting }) => {
              axios
                .post("auth/login", {
                  email: values.email,
                  password: values.password
                })
                .then(res => {
                  if(res.data){
                    if(res.data.error){
                      toast.error(res.data.error);
                    }else{
                      this.props.userLogin(res.data);
                      this.props.history.push('/dashboard');
                    }
                    
                  }
                  setSubmitting(false);
                }).catch(error => {  toast.error(error.message);setSubmitting(false); });
        }}
      >
        {({ isSubmitting }) => (
          <Form>
          <label htmlFor="email">{ this.props.termes.mailpassword.mailparamLabelEmail}</label>
            <Field type="email" name="email" />
            <ErrorMessage name="email"  className="error" component="div" />
            <label htmlFor="email">{ this.props.termes.mailpassword.mailparamLabelPassword}</label>
            <Field type="password" name="password" />
            <ErrorMessage name="password"  className="error" component="div" />
            <button type="submit" disabled={isSubmitting}>
            { this.props.termes.mailpassword.mailparamBTNLogin}
            </button>
          </Form>
        )}
    </Formik>
    </Fragment>
      );
    }
}

const mapStateToProps = (state)=>{
  return {
    token: state.auth.token,
    userinfos: state.auth.userinfos,
    termes: state.settings.termes
  }
};


export default connect(mapStateToProps, {userLogin})(withRouter(LoginForm));